function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9 18c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9zm-3.013-4.834c-1.32.577-2.234.983-2.987 1.547v.001c1.529 1.56 3.672 2.537 6.045 2.537 2.227.004 4.367-.87 5.955-2.433-1.392-1.224-3.015-1.755-3.378-1.86-1.026-.849-.613-1.793.138-3.132.113-.2.22-.4.319-.59.554-1.094.455-1.788.374-2.068.216-.788.409-2.977-.712-4.169-.666-.712-1.642-.916-2.908-.616-1.334.008-2.299.415-2.88 1.211-1 1.37-.474 3.42-.33 3.903-.283.988.294 1.67.414 1.8.135.185 1.66 2.346.383 3.682l-.433.187z",
  clipRule: "evenodd"
});

var SvgAdultRoundBorder = function SvgAdultRoundBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdultRoundBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adult-round-border.69f0ecc4.svg";
export { ForwardRef as ReactComponent };